import React, { useMemo } from "react";
import { Box } from "@edreamsodigeo/prisma-design-system";
import {
  createFeature,
  Desktop,
  useTranslation,
} from "@edreamsodigeo/frontend-core";

import { BrandBackground } from "~/components/common/BrandBackground";
import FlightsBannerTitle from "~/components/acquisition/RefundableFlightsBanner/FlightsBannerTitle";
import { generateContent } from "~/components/acquisition/RefundableFlightsBanner/config/constants";
import FlightsBannerContent from "~/components/acquisition/RefundableFlightsBanner/FlightsBannerContent";
import type { ContentGenerationProps } from "~/components/acquisition/RefundableFlightsBanner/contracts";
import useGetBenefitFromOffer from "~/clientState/hooks/useGetBenefitFromOffer";
import {
  SubscriptionOfferPeriod,
  SubscriptionOfferType,
  MembershipPerkType,
} from "~/generated/graphql";
import { FREE_CANCELLATION_DESKTOP_WAITING_PAGE } from "~/clientState/ab/teams/oprime";

const RefundableFlightsBanner: React.FC = () => {
  const { isBenefitIncluded } = useGetBenefitFromOffer({
    offerPeriod: SubscriptionOfferPeriod.FreeTrial,
    offerType: SubscriptionOfferType.Plus,
    perkType: MembershipPerkType.ItineraryCancellationForSubscriptionPurchase,
  });
  const { t } = useTranslation();

  const content: ContentGenerationProps = useMemo(() => {
    return generateContent(t);
  }, [t]);

  return isBenefitIncluded ? (
    <Desktop>
      <Box
        style={{ maxWidth: "800px", overflow: "hidden" }}
        borderRadius={"regular"}
      >
        <BrandBackground>
          <FlightsBannerTitle
            title={content.title}
            subtitle={content.subtitle}
          />
        </BrandBackground>
        <FlightsBannerContent content={{ ...content.body }} />
      </Box>
    </Desktop>
  ) : null;
};

const RefundableFlightsWaitingBanner = createFeature({
  name: FREE_CANCELLATION_DESKTOP_WAITING_PAGE,
  variations: [null, RefundableFlightsBanner],
  version: 2,
});

export default RefundableFlightsWaitingBanner;
